<template>
    <v-container class="filter-lesson-content">
        <!-- class list available  -->
        <template v-if="!mode">
            <!-- Header Filter-->
            <v-row class="header-filter" no-gutters>
                <!-- title -->
                <v-col cols="auto" class="d-none d-md-flex align-center">
                    <!--<img
                        class="filter-lesson-content__icon icon-class float-left"
                        src="@/assets/icons/online-course-purple.svg"
                        alt
                    />-->
                    <h1 class="float-left filter-lesson-content__title mr-10">
                        Mis Clases
                    </h1>
                </v-col>
                
                <!-- filter -->
                <v-col class="filter-wrapper">
                </v-col>
                
                <!-- new class btn -->
                <v-col cols="auto" class="d-none d-sm-block mx-4">
                    <v-btn
                        color="accent"
                        class="roma-btn-2 text-capitalize align-right"
                        :to="{ name: 'NewLesson' }"
                        rounded
                        large
                    >
                        <span>
                            Crear clase
                        </span>
                        <v-icon right dark class="d-none d-md-flex"
                            >mdi-plus</v-icon
                        >
                    </v-btn>
                </v-col>
                


                <!-- reorder icon -->
                <!--<v-col cols="auto" class="d-none d-sm-block text-center">
                    <v-btn
                        fab
                        large
                        color="gray-dark"
                        class="btn-view-list"
                        @click="toggleListMode()"
                    >
                        <template v-if="!getGridColumnLesson">
                            <v-icon>
                                card-mode
                            </v-icon>
                        </template>
                        <template v-else>
                            <v-icon>
                                list-mode
                            </v-icon>
                        </template>
                    </v-btn>
                </v-col>-->
            </v-row>
            
            <v-row>
            
                <!-- filter -->
                <v-col class="filter-wrapper">
                    <RomaFilter />
                </v-col>
            
            </v-row>
        </template>

        <!-- not class list available -->
        <template v-else>
            <v-row class="align-items-center header-filter">
                <v-col md="4" class="d-flex align-center">
                    <!-- <img class="icon-class float-left" src="../../assets/icons/my_class_icon.svg" alt /> -->
                    <img
                        class="filter-lesson-content__icon icon-class float-left"
                        src="@/assets/icons/online-course-purple.svg"
                        alt
                    />
                    <h1 class="filter-lesson-content__title">Mis Clases</h1>
                </v-col>
            </v-row>
            <v-row class="mode-new-lesson">
                <v-col cols="12">
                    <v-img
                        src="@/assets/images/no-class.svg"
                        class="mode-new-lesson__img"
                    ></v-img>
                </v-col>
                <v-col cols="12">
                    <p class="mode-new-lesson__description">
                        Empieza a crear tus clases para agregar las actividades
                        que compartiras a tus estudiantes.
                    </p>
                </v-col>
                <v-col cols="12" p-0 class="text-center">
                    <v-btn
                        color="accent"
                        class="roma-btn-2 text-capitalize"
                        :to="{ name: 'NewLesson' }"
                        rounded
                        large
                    >
                        <span>
                            Crear clase
                        </span>
                        <v-icon right dark>new-class</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import RomaFilter from "@/components/commons/RomaFilter.vue";
import { mapActions, mapGetters } from "vuex";
import RomaFormNewLesson from "./RomaFormNewLesson";

export default {
    props: ["mode"],
    name: "RomaFilterLesson",
    data() {
        return {
            items: [],
            component: RomaFormNewLesson,
            optionsFilter: [
                {
                    label: this.$vuetify.lang.t("Asignatura"),
                    type: "select",
                    cols: 3,
                    options: [
                        "Inglés",
                        "Matematica",
                        "Deportes",
                        "Lenguaje y Literatura"
                    ]
                },
                {
                    label: this.$vuetify.lang.t("Nivel"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Curso"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Unidad"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Título"),
                    type: "text",
                    cols: 6,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Fecha entrega inicio"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Fecha entrega fin"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Pie"),
                    type: "select",
                    cols: 3,
                    options: []
                },
                {
                    label: this.$vuetify.lang.t("Estado"),
                    type: "select",
                    cols: 3,
                    options: []
                }
            ]
            // cardMode: true
        };
    },
    components: {
        RomaFilter
    },
    computed: {
        ...mapGetters({
            getGridColumnLesson: "getGridColumnLesson"
        })
    },
    methods: {
        ...mapActions({
            toastSuccess: "toastSuccess",
            toastError: "toastError",
            updateFormLessonMode: "updateFormLessonMode",
            newFormLessonMode: "newFormLessonMode"
        }),
        showFilterModal() {
            this.showFilter = !this.showFilter;
        },
        toggleListMode() {
            this.$store.commit("SET_COLUMN_GRID_LESSON");
        }
    }
};
</script>

<style lang="scss">
.filter-lesson-content {
    &__dialog {
        .v-btn__content {
            display: grid;
            font-size: 16px;
            grid-template-columns: 32px max-content 32px;
            span {
                grid-column: 2 / 3;
            }
            i {
                grid: 3 / 4;
            }
        }
    }
    .mode-new-lesson {
        &__img {
            width: 300px;
            height: auto;
            margin: 0 auto;
        }
        &__description {
            text-align: center;
            max-width: 320px;
            margin: 0 auto;
        }
    }
    .header-filter {
        align-items: center;
        h1 {
            color: $morado;
        }
    }

    .container-search {
        margin-top: 0 !important;
    }

    .icon-class {
        color: $morado !important;
        margin: 0 20px 0 5px;
    }

    .theme--light.v-icon {
        color: $morado;
    }

    .input-search {
        min-height: 60px !important;
    }

    .reorder-icon:before {
        content: url("../../assets/icons/list-mode.svg");
    }

    .btn-view-list {
        padding: 5px !important;
        width: 50px !important;
        height: 50px !important;
        box-shadow: none;
        background: #e9e9e9 !important;
        i {
            color: map-get($colors, "gray-dart") !important;
        }
    }
    &__icon {
        width: auto;
    }
    @media (min-width: 1904px) {
        &__icon {
            height: 36px;
        }
        &__title {
            font-size: 36px;
        }
    }
    @media (min-width: 1264px) and (max-width: 1903px) {
        &__icon {
            height: 31px;
        }
        &__title {
            font-size: 31px;
        }
    }
    @media (min-width: 960px) and (max-width: 1263px) {
        &__icon {
            height: 25px;
        }
        &__title {
            font-size: 25px;
        }
    }
    @media (min-width: 600px) and (max-width: 959px) {
    }
    @media (max-width: 599px) {
    }
    @media (max-width: 959px) {
        .roma-btn-2 {
            .v-btn__content {
                grid-template-columns: 1fr;
            }
        }
    }
}
</style>
